import { render, staticRenderFns } from "./BaseStarIcon.vue?vue&type=template&id=c5e32c76"
import script from "./BaseStarIcon.vue?vue&type=script&lang=js"
export * from "./BaseStarIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports